<script>
import { getContext, onMount } from "svelte";
import { contextKey } from "@beyonk/svelte-mapbox";
const { getMap, getMapbox } = getContext(contextKey);
const map = getMap();
const mapbox = getMapbox();

let mapExpanded = false
function toggleMap(){
    mapExpanded = mapExpanded ? false : true
    map.resize();
    
}

</script>

<div class="expand" on:click={toggleMap}>
    <!-- <img src="/images/expand.svg" width="15" height="15" alt="Expand Map Fullscreen"/> -->

<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   viewBox="0 0 32.645298 32.66423"
   version="1.1"
   width="15"
   height="15">
a>
  <defs id="defs28" />
  <g
     stroke="none"
     stroke-width="1"
     fill="none"
     fill-rule="evenodd"
     id="g18"
     transform="translate(4.6153846e-4,6.92308e-4)">
    <g
       transform="translate(-1007,-3031)"
       fill="#000000"
       id="g16">
      <g
         transform="translate(-14,-75)"
         id="g14">
        <g
           transform="translate(307,2555)"
           id="g12">
          <g
             transform="translate(0,237)"
             id="g10">
            <g
               transform="translate(714,313)"
               id="g8">
              <path
                 d="m 32.556231,1.8554615 c 0.09231,0.2215385 0.103846,0.4592308 0.07385,0.6946154 V 14.409308 c 0,0.763846 -0.618462,1.384615 -1.382308,1.384615 -0.766154,0 -1.384615,-0.620769 -1.384615,-1.384615 V 5.7600769 l -9.516923,9.5146151 c -0.54,0.54 -1.416923,0.54 -1.956923,0 -0.542308,-0.54 -0.542308,-1.416923 0,-1.95923 l 9.546923,-9.5469235 h -8.683846 c -0.763847,0 -1.382308,-0.6184616 -1.382308,-1.3846154 0,-0.7638462 0.618461,-1.38461541 1.382308,-1.38461541 h 12.025384 c 0.0069,0 0.01154,0.004615 0.01615,0.004615 0.175385,0.00231 0.348462,0.034615 0.514615,0.1015384 0.336924,0.1407693 0.606923,0.413077 0.747693,0.7500004 z M 13.409539,30.894308 c 0.766153,0 1.384615,0.620769 1.384615,1.384615 0,0.763846 -0.618462,1.384616 -1.384615,1.384616 H 1.3841538 c -0.18,0 -0.36,-0.03692 -0.52846149,-0.106154 -0.33923077,-0.14077 -0.60923077,-0.41077 -0.75,-0.75 C 0.03876923,32.638923 -4.6153846e-4,32.461231 -4.6153846e-4,32.283538 v -0.0046 c 0,-0.05539 0.0253846185,-0.110769 0.0323076885,-0.166154 V 20.253538 c 0,-0.763846 0.62076924,-1.384615 1.38461535,-1.384615 0.7638462,0 1.3846154,0.620769 1.3846154,1.384615 v 8.649231 l 9.5215381,-9.521538 c 0.542308,-0.54 1.419231,-0.54 1.959231,0 0.54,0.542307 0.54,1.416923 0,1.95923 L 4.728,30.894308 Z"
                 id="path6" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>


</div>

<style>
.expand {
background: #000;
position: absolute;
right: 4px;
top: 4px;
z-index: 9999;
padding: 4px 6px;
cursor: pointer;
border-radius: 4px;
box-shadow: 0 0 2px #000;
}

#g16 {
    fill: #fff;
}


.expand:hover {
    background-color: #fff;
    box-shadow: 0 0 5px #000;
}

.expand:hover #g16 {
    fill: #000;
}


.expand svg {
width: 15px;
height: 15px;
vertical-align: middle;
}




.mapExpanded {
width:  100%;
height:  100%;
margin: 0;
}
</style>